import {DateTimeFormatter, LocalDate} from '@js-joda/core';
import type {CapacityConfig, CapacityConfigItem} from '@/types/CapacityConfig';

const formatter = DateTimeFormatter.ofPattern('M/d/yyyy');
export const capacityYearMonthFormatter = DateTimeFormatter.ofPattern('yyyy-MM');

const getConfigForDate = (
    capacityConfig : CapacityConfig,
    now = LocalDate.now()
) : CapacityConfigItem | undefined => {
    const foundKey = Object.keys(capacityConfig).find(configKey => {
        const configuration = capacityConfig[configKey];
        const fiscalStart = LocalDate.parse(configuration.fiscalstart, formatter);
        const fiscalEnd = LocalDate.parse(configuration.fiscalend, formatter);

        return now.isAfter(fiscalStart) && now.isBefore(fiscalEnd);
    });

    if (foundKey) {
        return capacityConfig[foundKey];
    }
};

export default getConfigForDate;
